module.exports = __webpack_public_path__ + "static/img/9.3506bb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/9.png
// module id = 0Tt2
// module chunks = 0